import {
    ArrowRight,
    Eye,
    HandHeart,
    LifeBuoy,
    type LucideIcon,
    MessagesSquare,
    Target,
} from 'lucide-react';

import { useBreakpointDown } from '@nesso/ui/hooks/use-breakpoint-down';

type RecapPrompt = {
    icon: LucideIcon;
    label: string;
    description: string;
};

const RECAP_PROMPTS: RecapPrompt[] = [
    { icon: Target, label: "Client's focus", description: 'Presenting concerns, themes, goals' },
    {
        icon: Eye,
        label: 'What you observed',
        description: 'Appearance, mood, affect, behaviors, notable shifts',
    },
    {
        icon: HandHeart,
        label: 'What you did',
        description: 'Interventions, techniques, approaches',
    },
    {
        icon: MessagesSquare,
        label: 'How they responded',
        description: 'Insight, engagement, progress',
    },
    {
        icon: LifeBuoy,
        label: 'Safety check',
        description: 'Risks, changes in safety or protective factors',
    },
    {
        icon: ArrowRight,
        label: "What's next?",
        description: 'Homework, treatment steps, next session focus',
    },
];

export function RecordingRecapCardList() {
    const isMobile = useBreakpointDown('md');

    if (isMobile) {
        return (
            <ul className="flex flex-col pl-2">
                {RECAP_PROMPTS.map(({ label, description }) => (
                    <li className="flex gap-2" key={label}>
                        <span
                            className="size-1.5 shrink-0 rounded-full bg-foreground mt-2"
                            aria-hidden="true"
                        />
                        <span className="text-sm text-foreground">
                            <span className="font-bold">{label}</span>: {description}
                        </span>
                    </li>
                ))}
            </ul>
        );
    }

    return (
        <ul className="flex flex-col">
            {RECAP_PROMPTS.map(({ icon: Icon, label, description }) => (
                <li className="flex items-center gap-4 p-4" key={label}>
                    <span className="flex size-8 shrink-0 items-center justify-center rounded-sm border border-secondary-border bg-secondary-background">
                        <Icon className="size-4 text-secondary" />
                    </span>
                    <span className="flex flex-col gap-1">
                        <span className="text-sm font-semibold text-foreground">{label}</span>
                        <span className="text-sm text-muted-foreground">{description}</span>
                    </span>
                </li>
            ))}
        </ul>
    );
}
